import React from 'react';

import { styled } from '../theme';
import { CommonComponentProps } from '../types/components';
import Text from './Text';

/**
 * Utils
 */

/**
 * Types
 */

type Props = {};

/**
 * Styled
 */
const StyledText = styled(Text)<Props>(({ theme }) => ({
    fontFamily: theme.typography.fontFamily.medium,
    fontWeight: theme.typography.fontWeight.medium,
    fontSize: '1.6rem',
    lineHeight: '2.2rem',
}));

/**
 * Component
 */

export default React.forwardRef<HTMLSpanElement, CommonComponentProps<HTMLSpanElement> & Props>(
    ({ ...props }, ref) => <StyledText ref={ref} {...props} />
);
